//import React from 'react';

const index = {
    5: {
        algebra: {
            title: 'Algebra',
            description: 'Beschreibung für Algebra',
            keywords: [''],
            types: {
                grundwissen: require('./5/Grundwissen/Algebra.txt'),
                aufgaben: require('./5/Aufgaben/Algebra.txt'),
                lösungen: require('./5/Loesungen/Algebra.txt')
            }
        },
        geometrie: {
            title: 'Geometrie',
            description: 'Beschreibung für Geometrie',
            keywords: [''],
            types: {
                grundwissen: require('./5/Grundwissen/Geometrie.txt'),
                aufgaben: require('./5/Aufgaben/Geometrie.txt'),
                lösungen: require('./5/Loesungen/Geometrie.txt')
            }
        },
        stochastik: {
            title: 'Stochastik',
            description: 'Beschreibung für Stochastik',
            keywords: [''],
            types: {
                grundwissen: require('./5/Grundwissen/Stochastik.txt'),
                aufgaben: require('./5/Aufgaben/Stochastik.txt'),
                lösungen: require('./5/Loesungen/Stochastik.txt')
            }
        },
        demo: {
            title: 'Demo-Thema',
            description: 'Nur ein Demo-Thema',
            keywords: ['demo', 'thema', 'keyword', 'test'],
            types: {
                demo: require('./demo.txt'),
                test: require('./test.txt'),
            }
        },
        // thema2 : {
        //     title : 'Titel für thema2',
        //     description : 'Description for thema2',
        //     keywords : ['2', 'hhhhh'],
        //     types : {
        //         aufgaben : require('./test.txt'),
        //         übungen : require('./demo.txt'),
        //     }
        // }
    },

    6: {
        algebra: {
            title: 'Algebra',
            description: 'Beschreibung für Algebra',
            keywords: [''],
            types: {
                grundwissen: require('./6/Grundwissen/Algebra.txt'),
                aufgaben: require('./6/Aufgaben/Algebra.txt'),
                // lösungen: require('./6/Loesungen/Algebra.txt')
            }
        },
        geometrie: {
            title: 'Geometrie',
            description: 'Beschreibung für Geometrie',
            keywords: [''],
            types: {
                grundwissen: require('./6/Grundwissen/Geometrie.txt'),
                aufgaben: require('./6/Aufgaben/Geometrie.txt'),
                // lösungen: require('./6/Loesungen/Geometrie.txt')
            }
        },
        // stochastik: {
        //     title: 'Stochastik',
        //     description: 'Beschreibung für Stochastik',
        //     keywords: [''],
        //     types: {
        //         // grundwissen: require('./6/Grundwissen/Stochastik.txt'),
        //         // aufgaben: require('./6/Aufgaben/Stochastik.txt'),
        //         // lösungen: require('./6/Loesungen/Stochastik.txt')
        //     }
        // }

    },
    7: {
        algebra: {
            title: 'Algebra',
            description: 'Beschreibung für Algebra',
            keywords: [''],
            types: {
                grundwissen: require('./7/Grundwissen/Algebra.txt'),
                // aufgaben: require('./7/Aufgaben/Algebra.txt'),
                // lösungen: require('./7/Loesungen/Algebra.txt')
            }
        },
        geometrie: {
            title: 'Geometrie',
            description: 'Beschreibung für Geometrie',
            keywords: [''],
            types: {
                grundwissen: require('./7/Grundwissen/Geometrie.txt'),
                // aufgaben: require('./7/Aufgaben/Geometrie.txt'),
                // lösungen: require('./7/Loesungen/Geometrie.txt')
            }
        },
        // stochastik: {
        //     title: 'Stochastik',
        //     description: 'Beschreibung für Stochastik',
        //     keywords: [''],
        //     types: {
        //         // grundwissen: require('./7/Grundwissen/Stochastik.txt'),
        //         // aufgaben: require('./7/Aufgaben/Stochastik.txt'),
        //         // lösungen: require('./7/Loesungen/Stochastik.txt')
        //     }
        // }
    },

    8: {

    },
    9: {

    },
    10: {

    }
};

export default index;